import React from "react";
import NavAdmin from "../nav-admin/nav-admin";
import useUserStore from "../../utils/storeApp";

const HeaderReports = () => {
  const { userRole } = useUserStore((state) => ({
    isUserLogedIn: state.isUserLogedIn,
    userRole: state.userRole,
    userToken: state.userToken,
  }));
  return (
    <header className="HeaderReports" >
      {userRole === "SES ADMINISTRATOR" ||
      userRole === "ADMINISTRATOR" ||
      userRole === "SYSTEMADMINISTRATOR" ? (
        <nav className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar" aria-label="Reports header bar with admin navigation">
        <div className="container w-max2">
            <h5 className="sp-mx" id="reports-header">
                <i className="bi bi-journal-medical" aria-hidden="true"></i>
                <span className="sp-margin12">Reports</span>
            </h5>
            <NavAdmin />
        </div>
        </nav>
      ) : null}
    </header>
  );
};

export default HeaderReports;
